export default __webpack_public_path__ + "static/media/penguin.43fce31b.jpg";